import React, { useRef, useEffect, useState, useCallback } from 'react';
import {
  Tabs,
  TabList,
  TabPanels,
  Tab,
	Flex,
	Icon,
	Text,
	Button,
	SimpleGrid,
	Switch,
	FormLabel,
	Divider,
	Table,
	Thead,
	Tr,
	Th,
	Tbody,
	Td,
	Tfoot,
	Avatar,
	useToast,
	Stack,
	Spinner,
	Image,
} from '@chakra-ui/react';
import { FormHandles } from '@unform/core';
import { v4 as uuid } from 'uuid';
import { format, add, addDays, addMonths, parseISO, getDaysInMonth } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';
import { FiArrowRight, FiCheckCircle, FiEdit, FiMinus, FiPlus, FiTrash2 } from 'react-icons/fi';
import * as Yup from 'yup';

import api from '../../../services/api';
import { useAuth } from '../../../hooks/auth';
import { formatPrice } from '../../../utils/format';
import formatPriceNumber from '../../../utils/formatPriceNumber';
import formatInputMoeda from '../../../utils/formatInputMoeda';
import getValidationErrors from '../../../utils/getValidationErrors';
import load from '../../../assets/loading/tres_pontos.gif';
import Input from '../../Inputs/Input';
import InputSelect from '../../Inputs/Selects/InputSelect';
import InputTextArea from '../../Inputs/inputTextArea';
import InputDate from '../../Inputs/InputDate';
import ModalParcelaEdit from '../ModalParcelaEdit';
import Alert from '../../Alert';
import { FinJsonDTO } from '../../../dtos/FinJsonDTO';
import { ClienteDTO } from '../../../dtos/ClienteDTO';
import { ParcelaDTO } from '../../../dtos/ParcelaDTO';
import ModalCadastroCliente from '../../ModalCadastroCliente';
import SelectInput from '../../Inputs/Selects/SelectInput';
import { AppError } from '../../../utils/AppError';

import {
  Container,
  Content,
  Header,
  TabsView,
	TabOperacao,
	TabTitulo,
	TabCliente,
  FormView,
  Buttons,
	ClienteItem,
	TabParcela,
	TabConta,
	LoadingView
} from './styles';

type GrauData = {
	value: string;
	label: string;
}
type ContaGrauData = {
	qtd_grau: number;
	grau_1: GrauData[];
	grau_2: GrauData[];
	grau_3: GrauData[];
	grau_4: GrauData[];
	grau_5: GrauData[];
}
type ParcelaParamData = {
	arredondar: string;
	ultima: string;
}

interface ModalParams {
	onClose: any;
	isVisible: boolean;
	titulo: FinJsonDTO;
	handleForm: () => Promise<void>;
}

const ModalTituloEdit: React.FC<ModalParams> = ({
  onClose = () => {},
  isVisible,
	titulo,
	handleForm
}) => {
  const formRef = useRef<FormHandles>(null);
  const formRefCliente = useRef<FormHandles>(null);
	const formRefParcela = useRef<FormHandles>(null);
	const formRefConta = useRef<FormHandles>(null);

	const { user } = useAuth();
	const toast = useToast();

  const [visible, setVisible] = useState(isVisible);
	const [loading, setLoading] = useState(true);

	const [openAlert, setOpenAlert] = useState(false);
	const [textAlert, setTextAlert] = useState({ header: '', body: '', is_toast: false });

	const [tabIndex, setTabIndex] = useState(0);
	const [disabledTabOperacao, setDisabledOperacao] = useState(false);
	const [disabledTabTitulo, setDisabledTitulo] = useState(true);
	const [disabledTabCliente, setDisabledCliente] = useState(true);
	const [disabledTabParcelas, setDisabledParcelas] = useState(true);
	const [disabledTabConta, setDisabledConta] = useState(true);

	const [tituloJson, setTituloJson] = useState<FinJsonDTO>({} as FinJsonDTO);

	const [radioOperacao, setRadioOperacao] = useState('');

	const [pays, setPays] = useState<any[]>([]);
	const [filteredPays, setFilteredPays] = useState<any[]>([]);
	const [operacoes, setOperacoes] = useState<any[]>([]);
	const [accounts, setAccounts] = useState<any[]>([]);
	const [tipoOps, setTipoOps] = useState<any[]>([]);
	const [filteredTipoOps, setFilteredTipodOps] = useState<any[]>([]);
	const [descriptionLength, setDescriptionLength] = useState(0);

	const [pesqClientes, setPesqCliente] = useState<ClienteDTO[]>([]);
	const [clienteSelected, setClienteSelected] = useState<ClienteDTO>({} as ClienteDTO);
	const [loadPesqCliente, setLoadPesqCliente] = useState(false);
	const [modalCadastroClienteVisible, setModalCadastroClienteVisible] = useState(false);

	const [parcelas, setParcelas] = useState<ParcelaDTO[]>([]);
	const [parcParams, setParcParams] = useState<ParcelaParamData>({} as ParcelaParamData);
	const [condPagDisabled, setCondPagDisabled] = useState(true);
	const [isOpenModalParcelaEdit, setIsOpenModalParcelaEdit] = useState(false);
	const [parcelaModal, setParcelaModal] = useState<ParcelaDTO>({} as ParcelaDTO);
	const [totalParcelas, setTotalParcelas] = useState(0);
	const [vlrParcAbertas, setVlrParcAbertas] = useState(0);

	const [grauContas, setGrauContas] = useState<ContaGrauData>({} as ContaGrauData);
	const [isDisabledButton, setIsDisabledButton] = useState(false);
	const [contas, setContas] = useState<any[]>([]);

	const [isLoadingTipoOps, setIsLoadingTipoOps] = useState(true);
	const [isLoadingPays, setIsLoadingPays] = useState(true);

	const selectDias = [
		{ id: 'Semanal', label: 'Semanal' },
		{ id: 'Decenal', label: 'Decenal' },
		{ id: 'Quinzenal', label: 'Quinzenal' },
		{ id: 'Mensal', label: 'Mensal' }
	];

	async function handleFilterTipoOps(e: any) {
		try {
			if (e) {
				formRef.current?.setFieldValue('tipo_op', undefined);
				const filtered = tipoOps.filter(tipo_op => tipo_op.type_op === e.type_op);
				setFilteredTipodOps([...filtered]);
			};
		} catch (error) {
			toast({
				title: 'Filtro Tipo op',
				description: 'Erro ao tentaer filtrar os tipos de operações',
				status: 'error',
				duration: 3000,
				position: 'top',
				isClosable: true,
				containerStyle: {
					marginTop: '5'
				}
			});
		} finally {
			setTimeout(() => {
				setIsLoadingTipoOps(false);
			}, 500);
		}
	};

	async function handleFilterPays(e: any) {
		try {
			if (e) {
				formRef.current?.setFieldValue('type_pay', undefined);
				const filtered = pays.filter(pay => pay.tip_conta === e.tip_conta);
				setFilteredPays([...filtered]);
			};
		}
		catch (error) {
			toast({
				title: 'Filtro pays',
				description: 'Erro ao tentar filtrar os pays',
				status: 'error',
				duration: 3000,
				position: 'top',
				isClosable: true,
				containerStyle: {
					marginTop: '5'
				}
			});
		}
		finally {
			setTimeout(() => {
				setIsLoadingPays(false);
			}, 500);
		}
	};

	async function fetchDadosPagina() {
		try {
			const { data } = await api.get('/portal/financeiro/tabelas/T');

			setPays([...data.pagamentos]);
			setOperacoes([...data.operacoes]);
			setAccounts([...data.contas]);
			setTipoOps([...data.tipo_ops]);
			setGrauContas({...data.grau_contas});
			setParcParams({...data.parc_params});

			if (titulo.id) {
				setDisabledOperacao(true);
				setDisabledTitulo(false);
				setDisabledCliente(false);
				setDisabledParcelas(false);
				setDisabledConta(false);

				titulo.parcelas[0].vlr_cred > 0 
					? setRadioOperacao('C')
					:	titulo.parcelas[0].vlr_deb > 0 && setRadioOperacao('D');

				const indexOp = data.operacoes.findIndex((op: any) => op.value === titulo.operacao.id);
				const indexTypeOp = data.tipo_ops.findIndex((type_op: any) => type_op.value === titulo.operacao.type_id);
				const indexConta = data.contas.findIndex((conta: any) => conta.value === titulo.operacao.caixa);
				const indexPag = data.pagamentos.findIndex((pag: any) => pag.value === titulo.pagamentos.id_pay);

				await handleFilterTipoOps(data.tipo_ops[indexTypeOp]);
				await handleFilterPays(data.pagamentos[indexPag]);

				formRef.current?.setData(titulo);
				formRef.current?.setFieldValue('vlr_doc', formatPrice(titulo.vlr_doc));

				setDescriptionLength(titulo.obs ? titulo.obs.length : 0);

				if (pesqClientes.length === 0) {
					setPesqCliente([...pesqClientes, titulo.cliente]);
				};

				const indexParcPago = titulo.parcelas.findIndex((item: ParcelaDTO) => item.amortizado > 0);

				if (indexParcPago > -1) {
					let auxVlrParcPagas = 0;

					titulo.parcelas.map((item: ParcelaDTO) => {
						auxVlrParcPagas = auxVlrParcPagas + (item.vlr_cred ? item.saldo_cred : item.saldo_deb);
					});

					setVlrParcAbertas(auxVlrParcPagas);
					setTotalParcelas(auxVlrParcPagas);
				}

				setTimeout(() => {
					formRef.current?.setFieldValue('op', data.operacoes[indexOp]);
					formRef.current?.setFieldValue('tipo_op', data.tipo_ops[indexTypeOp]);
					formRef.current?.setFieldValue('conta', data.contas[indexConta]);
					formRef.current?.setFieldValue('type_pay', data.pagamentos[indexPag]);

					setClienteSelected(titulo.cliente);
					setParcelas(titulo.parcelas);
					setContas(titulo.conta);

					setTituloJson(titulo);

					setTabIndex(1);
				}, 200);

				return;
			}
			else {
				formRef.current?.setFieldValue('vlr_doc', 'R$ 0,00');
			};

			setTituloJson({
				...tituloJson,
				id: uuid(),
				user_nome: user.nome
			});
			handleFilterPays(data.contas[0]);

			setTimeout(() => {
				formRef.current?.setFieldValue('conta', data.contas[0]);
			}, 200);
		}
		catch(error) {
			const isAppError = error instanceof AppError;
			const msg = isAppError ? error.message : 'Ocorreu um erro ao buscar dados da página.';

			toast({
				title: 'Dados da Página',
				description: msg,
				status: 'error',
				duration: 3000,
				position: 'top',
				isClosable: true,
				containerStyle: {
					marginTop: '5'
				}
			});
		}
		finally {
			setLoading(false);
		}
	}

  useEffect(() => {
		const fetch = async () => await fetchDadosPagina();
		fetch();
  }, []);

	function handleCancel(is_toast: boolean) {
		if (!is_toast) {
			const r = window.confirm(
				'Você não salvou suas alterações!\nDeseja sair sem salvar?',
			);

			if (r) {
				formRef.current?.reset();
				setVisible(false);
				onClose();
			} else { return; };
		};

		toast({
			title: `${titulo.id ? 'Edição' : 'Criação'} Título.`,
			description: `${titulo.id ? 'Edição' : 'Criação'} do título cancelada!`,
			status: 'warning',
			duration: 3000,
			position: 'top',
			isClosable: true,
			containerStyle: {
				marginTop: '5'
			}
		});

		formRef.current?.reset();
		setVisible(false);
		onClose();
	};

	async function handleSubmitTitulo(form: any, tab: number) {
		try {
			formRef.current?.setErrors({});

			const valor = formatPriceNumber(form.vlr_doc);

			form.vlr_doc = valor === 0 ? undefined : form.vlr_doc;

			const schema = Yup.object().shape({
				op: Yup.string().required('Operação obrigatório'),
				tipo_op: Yup.string().required('Tipo de operação obrigatório.'),
				conta: Yup.string().required('Conta obrigatório.'),
				doc: Yup.string().required('Valor do documento obrigatório'),
				vlr_doc: Yup.string().required('Valor do documento obrigatório'),
				data: Yup.string().required('Data de vencimento obrigatório'),
				type_pay: Yup.string().required('Tipo de pagamento obrigatório'),
				obs: Yup.string()
			});

			await schema.validate(form, {
				abortEarly: false,
			});

			let auxValor = form.vlr_doc.replace('R$', '');
			auxValor = auxValor.replace(' ', '');
			auxValor = auxValor.replace('.', '');
			auxValor = auxValor.replace(',', '.');

			const { doc, data, type_pay, obs, op, tipo_op, conta } = form;

			const indexPay = pays.findIndex(pay => pay.id_pay === type_pay);
			const auxPay = pays[indexPay];
			auxPay.vlr_pay = Number(auxValor);

			const indexOp = operacoes.findIndex(operacao => operacao.value === op);
			const auxOp = operacoes[indexOp];

			const indexTipoOp = tipoOps.findIndex(tipoOp => tipoOp.value === tipo_op);
			const auxTipoOp = tipoOps[indexTipoOp];

			const operacao = {
				id: auxOp.value,
				caixa: conta,
				nome: auxOp.label,
				titulo: auxOp.titulo,
				type_id: auxTipoOp.value,
				type_nome: auxTipoOp.label
			};

			setTituloJson({
				...tituloJson,
				doc,
				data,
				vlr_doc: Number(auxValor),
				pagamentos: auxPay,
				operacao,
				obs
			});

			setDisabledCliente(false);
			setTabIndex(tab);
		} catch (err) {
			if (err instanceof Yup.ValidationError) {
				const errors = getValidationErrors(err);
				formRef.current?.setErrors(errors);
				setDisabledCliente(true);
				setDisabledParcelas(true);
				setDisabledConta(true);
			}
		}
	};

	function handleSubmitCliente() {
		if (clienteSelected.id) {
			setTituloJson({...tituloJson, cliente: clienteSelected });
			setPesqCliente([...[], clienteSelected]);
			setDisabledParcelas(false);
			setTabIndex(3);
		}
	};

	const searchCliente = useCallback(async (form: any) => {
		try {
			const schema = Yup.object().shape({
				param: Yup.string().required('Parametro de pesquisa obrigatório'),
			});

			await schema.validate(form, {
				abortEarly: false,
			});

			setLoadPesqCliente(true);
			setPesqCliente([]);
			formRefCliente.current?.setErrors({});

			const { param } = form;

			await api.get(`/portal/cliente/${param}`)
				.then(response => {
					setPesqCliente(response.data);
				})
				.finally(() => {
					setLoadPesqCliente(false);
				});
		} catch (err) {
			if (err instanceof Yup.ValidationError) {
				const errors = getValidationErrors(err);
				formRefCliente.current?.setErrors(errors);
			}
		}
	}, []);

	async function handleSubmitParcelas() {
		if (parcelas.length === 0) {
			return;
		};

		let total_parcs = 0;
		const totalDoc = titulo.id ? vlrParcAbertas : tituloJson.vlr_doc;

		for (let i = 0; i < parcelas.length; i++) {
			const parcelaAtual = parcelas[i];
			const vlr_parcela = parcelaAtual.saldo_cred ? parcelaAtual.saldo_cred : parcelaAtual.saldo_deb;
			total_parcs = total_parcs + vlr_parcela;
		};

		if (total_parcs < totalDoc ) { // tituloJson.vlr_doc) {
			toast({
				title: 'Totais',
				description: 'Total das parcelas menor que total do documento!',
				status: 'warning',
				duration: 5000,
				position: 'top',
				isClosable: true,
				containerStyle: {
					marginTop: '5'
				}
			});

			return;
		}

		setTituloJson({
			...tituloJson,
			parcelas: parcelas,
			pagamentos: { ...tituloJson.pagamentos, max_parcel: parcelas.length }
		});

		const indexTipoOp = tipoOps.findIndex(tipo_op => tipo_op.value === tituloJson.operacao.type_id);

		// bloco para preencher os campos de contas da aba CONTAS
		if (tipoOps[indexTipoOp].conta) {
			const auxConta = tipoOps[indexTipoOp].conta.split('.');

			if (grauContas.grau_1.length > 0 && (!tituloJson.conta || tituloJson.conta?.length === 0)) {
				const indexT = grauContas.grau_1.findIndex(grau => grau.value === auxConta[0]);
				formRefConta.current?.setFieldValue('grau_1', grauContas.grau_1[indexT]);
			};
			if (grauContas.grau_2.length > 0 && (!tituloJson.conta || tituloJson.conta?.length === 0)) {
				const indexT = grauContas.grau_2.findIndex(grau => grau.value === auxConta[1]);
				formRefConta.current?.setFieldValue('grau_2', grauContas.grau_2[indexT]);
			};
			if (grauContas.grau_3.length > 0 && (!tituloJson.conta || tituloJson.conta?.length === 0)) {
				const indexT = grauContas.grau_3.findIndex(grau => grau.value === auxConta[2]);
				formRefConta.current?.setFieldValue('grau_3', grauContas.grau_3[indexT]);
			};
			if (grauContas.grau_4.length > 0 && (!tituloJson.conta || tituloJson.conta?.length === 0)) {
				const indexT = grauContas.grau_4.findIndex(grau => grau.value === auxConta[3]);
				formRefConta.current?.setFieldValue('grau_4', grauContas.grau_4[indexT]);
			};
			if (grauContas.grau_5.length > 0 && (!tituloJson.conta || tituloJson.conta?.length === 0)) {
				const indexT = grauContas.grau_5.findIndex(grau => grau.value === auxConta[4]);
				formRefConta.current?.setFieldValue('grau_5', grauContas.grau_5[indexT]);
			};
		}

		if (!tituloJson.conta || tituloJson.conta?.length === 0) {
			formRefConta.current?.setFieldValue('valor', formatPrice(tituloJson.vlr_doc));
		};

		setDisabledConta(false);
		setTabIndex(4);
	};

	async function handleCondicaoPag() {
		setParcelas([]);

		let vlr_total = tituloJson.vlr_doc;
		const condition = formRefParcela.current?.getFieldValue('cond_pag');
		const parcelass = condition.split(/[\.*+,:;/-]/g);

		const desconto = formRefParcela.current?.getFieldValue('desc');
		const mora = formRefParcela.current?.getFieldValue('juros');
		const multa = formRefParcela.current?.getFieldValue('multa');
		const protesto = formRefParcela.current?.getFieldValue('protesto');

		let auxPar = parcelass;
		let auxLength = parcelass.length;

		do {
			auxLength = auxPar.length;

			for (let i = 0; i < parcelass.length; i++) {
				auxPar[i] = Number(parcelass[i]);

				if (parcelass[i] === '') {
					auxPar.splice(i, 1);
				};
			}
		} while (auxLength > auxPar.length);

		await auxPar.sort((a: number, b: number) => a - b);

		let resto = Number((((vlr_total * 100) % auxPar.length) / 100).toFixed(2));

		if (parcParams.arredondar === 'S') {
			const auxVlrParc = Math.trunc(Number((vlr_total / auxPar.length).toFixed(2)));
			const auxTotal = auxVlrParc * auxPar.length;
			const auxResto = vlr_total - auxTotal;
			resto = Number(auxResto.toFixed(2));
		};

		for (let j = 0; j < auxPar.length; j++) {
			const data = format(addDays((new Date()), auxPar[j]), "yyyy'-'MM'-'dd", { locale: ptBR });
			// const data = format(add(new Date(), { days: auxPar[j] }), "yyyy'-'MM'-'dd", { locale: ptBR });

			let value_parcel = 0;

			if (parcParams.arredondar === 'S') {
				value_parcel = Math.trunc(Number((vlr_total / auxPar.length).toFixed(2)));
			} else {
				value_parcel = Number((vlr_total / auxPar.length).toFixed(2));
			};

			if (parcParams.ultima === 'S') {
				if (j === auxPar.length -1) {
					value_parcel = Number((value_parcel + resto).toFixed(2));
				}
			} else if (j === 0) {
				value_parcel = Number((value_parcel + resto).toFixed(2));
			};

			const auxParcela: ParcelaDTO = {} as ParcelaDTO;
			auxParcela.id = uuid();
			auxParcela.parcela = `${j+1}-${auxPar.length}`;
			auxParcela.vencimento = data;
			auxParcela.amortizado = 0;
			auxParcela.baixado = false;
			auxParcela.data_baixa = "";
			auxParcela.desconto = 0;
			auxParcela.juros = 0;
			auxParcela.multa = 0;
			auxParcela.outra_desp = 0;
			auxParcela.pago = 0;
			auxParcela.saldo_cred = radioOperacao === 'C' ? value_parcel : 0;
			auxParcela.saldo_deb = radioOperacao === 'D' ? value_parcel : 0;
			auxParcela.vlr_cred = radioOperacao === 'C' ? value_parcel : 0;
			auxParcela.vlr_deb = radioOperacao === 'D' ? value_parcel : 0;

			auxParcela.boleto = {
				linha_dig: '',
				nosso_nro: '',
				status: 'aberto',
				registro: 'Registrado',
				venc: data,
				vlr: value_parcel,
				desconto: desconto ? formatPriceNumber(desconto) : 0,
				mora: mora ? formatPriceNumber(mora) : 0,
				multa: multa ? formatPriceNumber(multa) : 0,
				protesto: protesto ? Number(protesto) : 0,
			};
 
			setParcelas(oldArray => [...oldArray, auxParcela]);
		};
	};

	async function handleQtdParcelas() {
		try {
			setParcelas([]);

			let vlr_total = tituloJson.vlr_doc;
			const qtdParc = Number(formRefParcela.current?.getFieldValue('qtd_parc'));
			const firstDate = formRefParcela.current?.getFieldValue('data_venc');
			// const diasSelect = Number(formRefParcela.current?.getFieldValue('dias'));
			const diasSelect = formRefParcela.current?.getFieldValue('dias');

			const desconto = formRefParcela.current?.getFieldValue('desc');
			const mora = formRefParcela.current?.getFieldValue('juros');
			const multa = formRefParcela.current?.getFieldValue('multa');
			const protesto = formRefParcela.current?.getFieldValue('protesto');

			let resto = Number((((vlr_total * 100) % qtdParc) / 100).toFixed(2));

			if (parcParams.arredondar === 'S') {
				// trunc descarta as casas decimais
				const auxVlrParc = Math.trunc(Number((vlr_total / qtdParc).toFixed(2)));
				const auxTotal = auxVlrParc * qtdParc;
				const auxResto = vlr_total - auxTotal;
				resto = Number(auxResto.toFixed(2));
			};

			let baseDate = firstDate;
			const dayBase = parseISO(baseDate).getDate();

			let total = 0;

			for (let i = 0; i < qtdParc; i++) {
				let dateCurrrent = '';

				if (i === 0) 
					dateCurrrent = format(parseISO(baseDate), "yyyy'-'MM'-'dd", { locale: ptBR });
				else 
					switch (diasSelect) {
						case 'Semanal':
							dateCurrrent = format(addDays(parseISO(baseDate), 7), "yyyy'-'MM'-'dd", { locale: ptBR });
							break;

						case 'Decenal':
							dateCurrrent = format(addDays(parseISO(baseDate), 10), "yyyy'-'MM'-'dd", { locale: ptBR });
							break;

						case 'Quinzenal':
							dateCurrrent = format(addDays(parseISO(baseDate), 15), "yyyy'-'MM'-'dd", { locale: ptBR });
							break;

						case 'Mensal':
							const nextMonth = addMonths(parseISO(baseDate), 1);
							const ultimoDiaMes = getDaysInMonth(nextMonth);

							// aqui garantimos que volta pro dia 30 quando existir
							const diaFinal = Math.min(dayBase, ultimoDiaMes);

							const dataFinal = new Date(nextMonth.getFullYear(), nextMonth.getMonth(), diaFinal);
							dateCurrrent = format(dataFinal, "yyyy'-'MM'-'dd", { locale: ptBR });
							break;
					};

				let value_parcel = 0;

				if (parcParams.arredondar === 'S') {
					// trunc descarta as casas decimais
					value_parcel = Math.trunc(Number((vlr_total / qtdParc).toFixed(2)));
				} else {
					value_parcel = Number((vlr_total / qtdParc).toFixed(2));
				};

				if (parcParams.ultima === 'S') {
					if (i === qtdParc - 1) {
						value_parcel = Number((value_parcel + resto).toFixed(2));
					}
				} else if (i === 0) {
					value_parcel = Number((value_parcel + resto).toFixed(2));
				};

				const auxParcela: ParcelaDTO = {} as ParcelaDTO;
				auxParcela.id = uuid();
				auxParcela.parcela = `${i + 1}-${qtdParc}`;
				auxParcela.vencimento = dateCurrrent;
				auxParcela.amortizado = 0;
				auxParcela.baixado = false;
				auxParcela.data_baixa = "";
				auxParcela.desconto = 0;
				auxParcela.juros = 0;
				auxParcela.multa = 0;
				auxParcela.outra_desp = 0;
				auxParcela.pago = 0;
				auxParcela.saldo_cred = radioOperacao === 'C' ? value_parcel : 0;
				auxParcela.saldo_deb = radioOperacao === 'D' ? value_parcel : 0;
				auxParcela.vlr_cred = radioOperacao === 'C' ? value_parcel : 0;
				auxParcela.vlr_deb = radioOperacao === 'D' ? value_parcel : 0;

				auxParcela.boleto = {
					linha_dig: '',
					nosso_nro: '',
					status: 'aberto',
					registro: 'Registrado',
					venc: dateCurrrent,
					vlr: value_parcel,
					desconto: desconto ? formatPriceNumber(desconto) : 0,
					mora: mora ? formatPriceNumber(mora) : 0,
					multa: multa ? formatPriceNumber(multa) : 0,
					protesto: protesto ? Number(protesto) : 0,
				};

				setParcelas(oldArray => [...oldArray, auxParcela]);
				// dias = dias + 30; // diasSelect;
				baseDate = dateCurrrent;
				total = total + value_parcel;
			};

			setTotalParcelas(total);

		} catch (error) {
			console.log('ERROR add parcelas ==> ', error);
		}
	};

	async function handleCaracter() {
		let texto = formRefParcela.current?.getFieldValue('cond_pag');
		texto = await texto.replace(/[ ?¿<>|{}[\]±ªº=_´`~^çÇ!#$%^&()\\a-zA-Z]/g, '');

		formRefParcela.current?.setFieldValue('cond_pag', `${texto}`);
	};

	async function handleSubmitGrausConta(data: any) {
		try {
			formRefConta.current?.setErrors({});

			let schema;

			if (data.hasOwnProperty('grau_2')) {
				if (data.hasOwnProperty('grau_3')) {
					if (data.hasOwnProperty('grau_4')) {
						if (data.hasOwnProperty('grau_5')) {
							schema = Yup.object().shape({
								grau_1: Yup.string().required('Grau 1 obrigatório'),
								grau_2: Yup.string().required('Grau 2 obrigatório'),
								grau_3: Yup.string().required('Grau 3 obrigatório'),
								grau_4: Yup.string().required('Grau 4 obrigatório'),
								grau_5: Yup.string().required('Grau 5 obrigatório'),
								valor: Yup.string().required('Valor da conta obrigatório.'),
							});
						} else {
							schema = Yup.object().shape({
								grau_1: Yup.string().required('Grau 1 obrigatório'),
								grau_2: Yup.string().required('Grau 2 obrigatório'),
								grau_3: Yup.string().required('Grau 3 obrigatório'),
								grau_4: Yup.string().required('Grau 4 obrigatório'),
								valor: Yup.string().required('Valor da conta obrigatório.'),
							});
						}
					} else {
						schema = Yup.object().shape({
							grau_1: Yup.string().required('Grau 1 obrigatório'),
							grau_2: Yup.string().required('Grau 2 obrigatório'),
							grau_3: Yup.string().required('Grau 3 obrigatório'),
							valor: Yup.string().required('Valor da conta obrigatório.'),
						});
					}
				} else {
					schema = Yup.object().shape({
						grau_1: Yup.string().required('Grau 1 obrigatório'),
						grau_2: Yup.string().required('Grau 2 obrigatório'),
						valor: Yup.string().required('Valor da conta obrigatório.'),
					});
				}
			} else {
				schema = Yup.object().shape({
					grau_1: Yup.string().required('Grau 1 obrigatório'),
					valor: Yup.string().required('Valor da conta obrigatório.'),
				});
			};

			await schema.validate(data, {
				abortEarly: false,
			});

			let numero = data.grau_1 ? `${data.grau_1}` : '';
			numero = data.grau_2 ? `${numero}.${data.grau_2}` : numero;
			numero = data.grau_3 ? `${numero}.${data.grau_3}` : numero;
			numero = data.grau_4 ? `${numero}.${data.grau_4}` : numero;
			numero = data.grau_5 ? `${numero}.${data.grau_5}` : numero;

			const exists = contas.findIndex(conta => conta.id === numero);
			if (exists !== -1) {
				toast({
					title: 'Conta Igual.',
					description: 'Já existe uma conta igual adicionada!',
					status: 'warning',
					duration: 5000,
					position: 'top-right',
					isClosable: true,
					containerStyle: {
						marginTop: '20'
					}
				});
				return;
			};

			let nome;

			if (data.grau_1) {
				const indexGrau1 = grauContas.grau_1.findIndex(grau => grau.value === data.grau_1);
				nome = grauContas.grau_1[indexGrau1].label;
			};
			if (data.grau_2) {
				const indexGrau2 = grauContas.grau_2.findIndex(grau => grau.value === data.grau_2);
				nome = `${nome} - ${grauContas.grau_2[indexGrau2].label}`;
			};
			if (data.grau_3) {
				const indexGrau3 = grauContas.grau_3.findIndex(grau => grau.value === data.grau_3);
				nome = `${nome} - ${grauContas.grau_3[indexGrau3].label}`;
			};
			if (data.grau_4) {
				const indexGrau4 = grauContas.grau_4.findIndex(grau => grau.value === data.grau_4);
				nome = `${nome} - ${grauContas.grau_4[indexGrau4].label}`;
			};
			if (data.grau_5) {
				const indexGrau5 = grauContas.grau_5.findIndex(grau => grau.value === data.grau_5);
				nome = `${nome} - ${grauContas.grau_5[indexGrau5].label}`;
			};

			const vlr_total = tituloJson.vlr_doc;

			let vlr = data.valor;
			vlr = await vlr.replace('R$', '').replace(' ', '').replace('.', '').replace(',', '.');
			vlr = Number(vlr);

			const auxConta = {
				id: numero,
				nome,
				percent: (vlr * 100) / vlr_total,
				vlr_cred: radioOperacao === 'C' ? vlr : 0,
				vlr_deb: radioOperacao === 'D' ? vlr : 0,
			};

			let resto = vlr_total;

			contas.map(conta => {
				resto = Number((resto - (radioOperacao === 'C' ? conta.vlr_cred : conta.vlr_deb)).toFixed(2))
			});

			resto = resto - vlr;

			setContas((oldArray: any) => [...oldArray, auxConta]);
			formRefConta.current?.reset();

			if (resto > 0) {
				setIsDisabledButton(false);
				formRefConta.current?.setFieldValue('valor', formatPrice(resto));
			} else {
				setIsDisabledButton(true);
			}
		} catch (err) {
			if (err instanceof Yup.ValidationError) {
				const errors = getValidationErrors(err);
				formRefConta.current?.setErrors(errors);
			}
		}
	};

	async function handleRemoveGrauConta(id: string) {
		const indexConta = contas.findIndex(conta => conta.id === id);
		const auxContas = contas;
		auxContas.splice(indexConta, 1);

		let resto = tituloJson.vlr_doc;
		auxContas.map(conta => 
			resto = Number((resto - (radioOperacao === 'C' ? conta.vlr_cred : conta.vlr_deb)).toFixed(2)));

		if (resto > 0) {
			setIsDisabledButton(false);
			formRefConta.current?.setFieldValue('valor', formatPrice(resto));
		} else {
			setIsDisabledButton(true);
		};

		setContas([...auxContas]);
	};

	async function handleVerifValor(valor: string) {
		let resto = tituloJson.vlr_doc;
		let campo;

		contas.map(conta =>
			resto = Number((resto - (radioOperacao === 'C' ? conta.vlr_cred : conta.vlr_deb)).toFixed(2)));

		campo = document.getElementById('valor_conta');

		if (formatPriceNumber(valor) > resto) {
			if (campo) {
				campo.textContent = `Valor superior ao resto do valor do titulo! (${formatPrice(resto)})`;
				campo.style.visibility = "visible";
				setIsDisabledButton(true);
			}
		} else {
			if (campo) {
				campo.style.visibility = "hidden";
				setIsDisabledButton(false);
			}
		}
	};

	async function handleSubmitCadastro() {
		setLoading(true);
		setTituloJson({ ...tituloJson, conta: contas });
		const auxTituloJson = { ...tituloJson, conta: contas };

		await api.post('/portal/financeiro/store', { financeiro: auxTituloJson})
			.then(() => {
				toast({
					title: 'Título.',
					description: 'Você salvou um novo título!',
					status: 'success',
					duration: 5000,
					position: 'top',
					isClosable: true,
					containerStyle: {
						marginTop: '5'
					}
				});
			})
			.catch(err => {
				toast({
					title: 'Erro',
					description: `Tente novamente mais tarde - ${err}`,
					status: 'error',
					duration: 5000,
					position: 'top',
					isClosable: true,
					containerStyle: {
						marginTop: '5'
					}
				});
			}).finally(async () => {
				await handleForm();
				setVisible(false);
				onClose();
			});
	};

  return (
    <Container id="ModalTituloEdit">
      <Content className={`${visible ? 'active' : ''}`}>
				{loading && (
					<LoadingView>
						<img src={load} alt="LoadingView" />
					</LoadingView>
				)}

				<Header style={{ display: 'flex', justifyContent: 'space-between' }}>
					<Flex align="center" ml={-4}>
						<Avatar
							name='cliente'
							src='https://safetycloud.blob.core.windows.net/razio-avatar/user.png'
							size="md"
							mt={-2}
						/> &nbsp;&nbsp;
						<Text
							fontSize={[16, 24]}
							fontWeight={500}
						>
							{tituloJson?.cliente ? tituloJson.cliente.nome : 'Cliente' }
						</Text>
					</Flex>

					<Flex flexDir="column">
						{radioOperacao !== '' && (
							<Flex
								align="center"
								borderRadius="full"
								background={radioOperacao === 'C' ? 'blue.200' : 'red.100'}
								color={radioOperacao === 'C' ? 'blue.900' : 'red.900'}
								px={2}
								pl={4}
							>
								<Text
									fontSize={[tituloJson.vlr_doc ? 16 : 20, tituloJson.vlr_doc ? 22 : 30]}
									fontWeight={600}
								>
									{radioOperacao === 'C' ? `Crédito` : 'Débito'}
								</Text>

								{radioOperacao === 'C' ? (
									<Icon as={FiPlus} fontSize={[23, 25]} />
								) : (
									<Icon as={FiMinus} fontSize={[23, 25]} />
								)}
							</Flex>
						)}

						{(tituloJson.vlr_doc && tituloJson.vlr_doc > 0.00) && (
							<Text
								fontSize={[15, 17]}
								fontWeight={600}
								textAlign="center"
								pt={[0, 1]}
							>
								{vlrParcAbertas ? formatPrice(vlrParcAbertas) : formatPrice(tituloJson.vlr_doc)}
							</Text>
						)}
					</Flex>
				</Header>

				<TabsView>
					<Tabs className="tabs" index={tabIndex}>
						<TabList className="tab-list" mt={-2} overflowX="auto" scrollBehavior="smooth">
							<Tab className="tab" isDisabled={disabledTabOperacao}>Operação</Tab>

							<Tab className="tab"
								isDisabled={disabledTabTitulo}
								onClick={() => setTabIndex(1)}>Titulo</Tab>

							<Tab className="tab"
								isDisabled={disabledTabCliente}
								onClick={() => handleSubmitTitulo(formRef.current?.getData(), 2)}>
								Cliente
							</Tab>

							<Tab className="tab"
								isDisabled={disabledTabParcelas}
								onClick={() => {
									if (titulo.id && tabIndex === 1) {
										handleSubmitTitulo(formRef.current?.getData(), 3);
									} else {
										setTabIndex(3);
									}
								}}>Parcelas</Tab>

							<Tab className="tab"
								isDisabled={disabledTabConta}
								onClick={() => {
									if (titulo.id && tabIndex === 1) {
										handleSubmitTitulo(formRef.current?.getData(), 4);
									} else {
										setTabIndex(4);
									}
								}}>Contas</Tab>
						</TabList>

						<TabPanels className="tab-panels">
							<TabOperacao className="tab-panel">
								<div className="tab-content">
									<Header>
										<h1>Operação</h1>
										<h2>Escolha aqui a operação do titulo débito ou crédito.</h2>
									</Header>

									<Flex h="90px" w="100%" mt={4}>
										<Button
											w="100%"
											h="100%"
											mr={1}
											colorScheme="blue"
											fontSize={20}
											borderRadius={10}
											onClick={() => {
												setRadioOperacao('C');
												setDisabledTitulo(false);
												setDisabledOperacao(true);
												setTabIndex(1);
											}}
										>
											CRÉDITO &nbsp;&nbsp;
											{radioOperacao === 'C' && (
												<Icon as={FiCheckCircle} fontSize={30} />
											)}
										</Button>

										<Button
											w="100%"
											h="100%"
											ml={1}
											colorScheme="red"
											fontSize={20}
											borderRadius={10}
											onClick={() => {
												setRadioOperacao('D');
												setDisabledTitulo(false);
												setDisabledOperacao(true);
												setTabIndex(1);
											}}
										>
											DÉBITO &nbsp;&nbsp;
											{radioOperacao === 'D' && (
												<Icon as={FiCheckCircle} fontSize={30} />
											)}
										</Button>
									</Flex>

									<Buttons>
										<Flex flexDir="column" pl={4} py={0}>
											<Text fontSize={[10, 14]} fontWeight={400}>Usuário:</Text>
											<Text pl={2} fontSize={[11, 15]} fontWeight={500}>{user.nome}</Text>
										</Flex>

										<Flex className="buttons">
											<button
												type="button"
												className="button-cancel"
												onClick={() => {
													setTextAlert({
														header: `Cancelar ${titulo.id ? 'Alteração' : 'Criação'} do Título!`,
														body: 'Você não salvou suas alterações!' + "\n" + 'Deseja sair sem salvar?',
														is_toast: true,
													});
													setOpenAlert(true);
												}}
											>
												Cancelar
											</button>
										</Flex>
									</Buttons>
								</div>
							</TabOperacao>

							<TabTitulo className="tab-panel" overflowY="auto" scrollBehavior="smooth">
								<div className="tab-content">
									<Header style={{ marginBottom: '0px' }}>
										<h1>Titulo</h1>
										<h2>Dados do título</h2>
									</Header>

									<Divider my={1} />

									<FormView ref={formRef} onSubmit={(e) => handleSubmitTitulo(e, 2)}>
										{/* OPERACAO - TIPO OPERAÇÃO */}
										<Stack w="100%" spacing={[0, 4]} direction={['column', 'column', 'row']}>
											{/* OPERACAO */}
											<div className="input">
												<p>Operação <span>(obrigatório)</span></p>
												<SelectInput
													name="op"
													placeholder="Operação"
													options={operacoes}
													onChange={(e: any) => {
														setIsLoadingTipoOps(true);
														handleFilterTipoOps(e);
													}}
												/>
											</div>

											{/* TIPO OPERAÇÃO */}
											<div className="input">
												<p>Tipo de operação <span>(obrigatório)</span></p>
												<SelectInput
													name="tipo_op"
													placeholder="Tipo de operação"
													isLoading={isLoadingTipoOps}
													isDisabled={isLoadingTipoOps}
													options={filteredTipoOps}
												/>
											</div>
										</Stack>

										{/* CONTA - TIPO DE PAGAMENTO */}
										<Stack w="100%" spacing={[0, 4]} direction={['column', 'column', 'row']}>
											{/* CONTA */}
											<div className="input">
												<p>Conta / Caixa <span>(obrigatório)</span></p>
												<SelectInput
													name="conta"
													placeholder="Conta/Caixa"
													options={accounts}
													onChange={(e: any) => {
														setIsLoadingPays(true);
														handleFilterPays(e);
													}}
												/>
											</div>

											{/* TIPO DE PAGAMENTO */}
											<div className="input">
												<p>Tipo de pagamento <span>(obrigatório)</span></p>
													<SelectInput
														name="type_pay"
														placeholder="Pagamentos"
														isLoading={isLoadingPays}
														isDisabled={isLoadingPays}
														options={filteredPays}
													/>
											</div>
										</Stack>

										{/* VALOR - NÚMERO */}
										<Stack w="100%" spacing={[0, 4]} direction={['column', 'column', 'row']}>
											{/* VALOR */}
											< div className="input">
												<p>Valor <span>(obrigatório)</span></p>
												<Input
													name="vlr_doc"
													type="text"
													placeholder="Valor do título"
													onChange={() => {
														formatInputMoeda('vlr_doc', formRef);
														if (titulo.id) {
															setParcelas([]);
															setContas([]);
															setDisabledParcelas(true);
															setDisabledConta(true);
														};
													}}
													disabled={titulo.baixas && titulo.baixas.length > 0}
													containerStyle={{ padding: '6px 0 6px 10px' }}
												/>
											</div>

											{/* NÚMERO */}
											<div className="input">
												<p>Nº Documento <span>(obrigatório)</span></p>
												<Input
													name="doc"
													type="text"
													placeholder="Número do título"
													containerStyle={{ padding: '6px 0 6px 10px' }}
												/>
											</div>
										</Stack>

										{/* DATA EMISSÃO - OBS */}
										<Stack w="100%" spacing={[0, 4]} direction={['column', 'column', 'row']}>
											{/* DATA EMISSÃO */}
											<div className="input">
												<p>Data de Emissão <span>(obrigatório)</span></p>
												<InputDate
													name="data"
													placeholder="data do título"
													defaultValue={format(new Date(), "Y'-'MM'-'dd", { locale: ptBR })}
													containerStyle={{ padding: '6px 10px' }}
												/>
											</div>

											{/* OBS */}
											<div className="input">
												<p>Observação</p>
												<InputTextArea
													name="obs"
													placeholder="Observação do título"
													rows={3}
													cols={4}
													max={5000}
													onChange={(e: any) => setDescriptionLength(e.target.value.length)}
													containerStyle={{ padding: '6px 0 6px 10px' }}
												/>

												<span>
													{descriptionLength}/5000
													caracteres
												</span>
											</div>
										</Stack>

										<Buttons>
											<Flex flexDir="column" pl={4} py={0}>
												<Text fontSize={[10, 14]} fontWeight={400}>Usuário:</Text>
												<Text pl={2} fontSize={[11, 15]} fontWeight={500}>{user.nome}</Text>
											</Flex>

											<Flex className="buttons">
												<button
													type="button"
													className="button-cancel"
													onClick={() => {
														setTextAlert({
															header: `Cancelar ${titulo.id ? 'Alteração' : 'Criação'} do Título!`,
															body: 'Você não salvou suas alterações!' + "\n" + 'Deseja sair sem salvar?',
															is_toast: true,
														});
														setOpenAlert(true);
													}}
												>
													Cancelar
												</button>

												<button type="submit" className="button-save">
													Próximo
												</button>
											</Flex>
										</Buttons>
									</FormView>
								</div>
							</TabTitulo>

							<TabCliente className="tab-panel">
								<div className="tab-content">
									<Header>
										<Flex w="100%" justify="space-between" align="center">
											<Flex flexDir="column">
												<h1>Cliente</h1>
												<h2>Adicione ou altera aqui o cliente.</h2>
											</Flex>

											{/* BUTTON NOVO */}
											<Flex flexDir="column" justify="flex-end">
												<button
													type="button"
													className="button-save"
													onClick={() => setModalCadastroClienteVisible(true)}
													style={{ display: 'flex', alignItems: 'center', margin: 0 }}
												>
													<Icon as={FiPlus} fontSize={18} />&nbsp;
													<Text>Novo</Text>
												</button>
											</Flex>
										</Flex>
									</Header>

									<FormView ref={formRefCliente} onSubmit={searchCliente}>
										<Stack spacing={2} direction="row" w="100%">
											{/* CLIENTE */}
											<div className="input">
												<p>Cliente</p>
												<Input
													name="param"
													type="text"
													placeholder="pesquisa"
													containerStyle={{ padding: '5px 10px' }}
												/>
											</div>

											<Flex flexDir="column" justify="flex-end">
												<button type="submit" className="button-save" style={{ margin: 0 }}>
													Buscar
												</button>
											</Flex>
										</Stack>
									</FormView>

									{pesqClientes.length > 0 ? (
										<SimpleGrid
											display="block"
											borderWidth={2}
											borderColor="gray.100"
											borderRadius={6}
											columns={1}
											spacing={4}
											overflowY="scroll"
											scrollBehavior="smooth"
											mb={10}
										>
											{pesqClientes.map((cliente: any) => {
												return (
													<ClienteItem key={cliente.id} selected={cliente.id === clienteSelected.id}>
														<Flex justify="space-between" align="center">
															<Flex w={["25%", "12%"]}>
																<Image
																	src={
																		cliente.avatar_url
																			? cliente.avatar_url
																			: 'https://safetycloud.blob.core.windows.net/cashback-promocoes/placeholder-image.png'
																	}
																	alt="Imagem Perfil"
																	boxSize="50px"
																	borderRadius="full"
																	objectFit="cover"
																/>
															</Flex>

															<Flex flexDir="column" w="100%">
																<Text fontWeight={600} color={cliente.id === clienteSelected.id ? "white" : "blue.500"}>
																	{cliente.nome}
																</Text>

																<Text fontSize={[12, 13]} fontWeight={500} color={cliente.id === clienteSelected.id ? "white" : "gray.800"}>
																	{cliente.id}
																</Text>

																<Stack direction={["column", "row"]} spacing={[0, 4]}>
																	<h2>
																		Doc: <span>{cliente.doc ? cliente.doc : "--"}</span>
																	</h2>

																	<h2>
																		Tel: <span>{cliente.phone ? cliente.phone : "--"}</span>
																	</h2>
																</Stack>

																<h2>
																	Cidade: <span>{cliente.cid ? cliente.cid : "--"}</span>
																</h2>
															</Flex>

															<Flex w={["2%", "10%"]} justify="flex-end">
																{clienteSelected.id && cliente.id === clienteSelected.id ? (
																	<Icon as={FiCheckCircle} />
																) : (
																	<Icon 
																		as={FiArrowRight}
																		cursor="pointer"
																		onClick={() => setClienteSelected(cliente)}
																	/>
																)}
															</Flex>
														</Flex>
													</ClienteItem>
												)
											})}
										</SimpleGrid>
									) : (
										<Flex justify="center" >
												{loadPesqCliente ? (
													<Spinner
														thickness='4px'
														speed='0.65s'
														emptyColor='gray.50'
														color='blue.500'
														size='lg'
														m={4}
													/>
												) : (
												<h2>Nenhum cliente encontrado</h2>
												)}
										</Flex>
									)}

									<Buttons>
										<Flex flexDir="column" pl={4} py={0}>
											<Text fontSize={[10, 14]} fontWeight={400}>Usuário:</Text>
											<Text pl={2} fontSize={[11, 15]} fontWeight={500}>{user.nome}</Text>
										</Flex>

										<Flex className="buttons">
											<button
												type="button"
												className="button-cancel"
												onClick={() => {
													setTextAlert({
														header: `Cancelar ${titulo.id ? 'Alteração' : 'Criação'} do Título!`,
														body: 'Você não salvou suas alterações!' + "\n" + 'Deseja sair sem salvar?',
														is_toast: true,
													});
													setOpenAlert(true);
												}}
											>
												Cancelar
											</button>

											<button
												type="button"
												className="button-save"
												onClick={handleSubmitCliente}
											>
												Proximo
											</button>
										</Flex>
									</Buttons>
								</div>
							</TabCliente>

							<TabParcela className="tab-panel">
								<div className="tab-content">
									<Header>
										<h1>Parcelas</h1>
										<h2>Adicione ou altera aqui as parcelas.</h2>
									</Header>

									<Divider my={0} />

									<FormView ref={formRefParcela} onSubmit={() => {}}>
										<Flex flexDir="column" w="100%">
											<Flex flexDir="column" w="100%">

												{/* JUROS - MULTA - DESCONTO - PROTESTO */}
												<Stack spacing={2} direction="row" w="100%">
													{/* JUROS */}
													<div className="input">
														<p>Juros</p>
														<Input
															name="juros"
															placeholder="Juros"
															containerStyle={{ padding: '5px 10px' }}
															onChange={() => formatInputMoeda('juros', formRefParcela)}
														/>
													</div>

													{/* MULTA */}
													<div className="input">
														<p>Multa</p>
														<Input
															name="multa"
															placeholder="Multa"
															containerStyle={{ padding: '5px 10px' }}
															onChange={() => formatInputMoeda('multa', formRefParcela)}
														/>
													</div>

													{/* DESCONTO */}
													<div className="input">
														<p>Desconto</p>
														<Input
															name="desc"
															placeholder="Desconto"
															containerStyle={{ padding: '5px 10px' }}
															onChange={() => formatInputMoeda('desc', formRefParcela)}
														/>
													</div>

													{/* PROTESTO */}
													<div className="input">
														<p>Protesto</p>
														<Input
															name="protesto"
															type="number"
															placeholder="Protesto"
															containerStyle={{ padding: '5px 10px' }}
															onChange={(e: any) => {
																if(e.target.value.length === 3) {
																	e.target.value = e.target.value.slice(0, -1);
																};
															}}
														/>
													</div>
												</Stack>

												<Flex
													align="center"
													background="gray.50"
													borderRadius={8}
													px={4} py={1} mt={3} mb={2}
												>
													<FormLabel htmlFor='email-alerts' mb={0}>
														Usar condição de pagamento?
													</FormLabel>

													<Switch
														id="email-alerts"
														isChecked={condPagDisabled}
														onChange={() => setCondPagDisabled(!condPagDisabled)}
														disabled={titulo.baixas && titulo.baixas.length > 0}
													/>
												</Flex>

												{/* CONDIÇÃO PAGAMENTO */}
												<Stack
													justify="space-between"
													spacing={2}
													direction={["column", "row"]}
													w="100%"
													mt={[-2, -2]}
													display={!condPagDisabled ? 'none' : 'flex'}
												>
													{/* CONDIÇÃO PAGAMENTO */}
													<Flex w="100%">
													<div className="input">
														<p>Condição de Pagamento <span>(ex. 30/60/90)</span></p>
														<Input
															name="cond_pag"
															placeholder="Condição de pagamento"
															containerStyle={{ padding: '5px 10px' }}
															onChange={handleCaracter}
															// disabled={!condPagDisabled}
															disabled={!condPagDisabled ||(titulo.baixas && titulo.baixas.length > 0)}
														/>
													</div>
													</Flex>

													<Flex flexDir="column" justify="flex-end" h="100%">
														<button
															type="submit"
															className="button-save"
															// disabled={!condPagDisabled}
															disabled={!condPagDisabled || (titulo.baixas && titulo.baixas.length > 0)}
															onClick={handleCondicaoPag}
															style={{ margin: 0 }}
														>
															&nbsp;&nbsp;&nbsp;Criar&nbsp;&nbsp;&nbsp;
														</button>
													</Flex>
												</Stack>
											</Flex>

											<Divider mt={2} mb={2} />

											{/* QTD PARCELAS - PRIMEIRO VENCIMENTO - DIAS */}
											<Stack 
												spacing={2}
												direction={["column", "row"]}
												mt={[-3, -3]}
												display={condPagDisabled ? 'none' : 'block'}
											>
												{/* QTD PARCELAS - PRIMEIRO VENCIMENTO */}
												<Stack spacing={2} direction="row" w="100%" mb={[-3, 0]}>
													{/* QTD PARCELAS */}
													<div className="input">
														<p>Qtd de Parcelas</p>
														<Input
															name="qtd_parc"
															placeholder="Qtd de parcelas"
															type="number"
															disabled={condPagDisabled}
															containerStyle={{ padding: '5px 10px' }}
														/>
													</div>

													{/* PRIMEIRO VENCIMENTO */}
													<div className="input">
														<p>1º Vencimento</p>
														<InputDate
															name="data_venc"
															placeholder="data do título"
															disabled={condPagDisabled}
															containerStyle={{ padding: '4px 10px' }}
														/>
													</div>
												</Stack>

												{/* DIAS - BUTTON */}
												<Stack spacing={2} direction="row" w={["100%", "70%"]}>
													{/* DIAS */}
													<div className="input">
														<p>Dias</p>
														<InputSelect
															name="dias"
															options={selectDias}
															placeholder="Dias"
															defaultValue=""
															disabled={condPagDisabled}
															containerStyle={{ padding: '5px 10px' }}
														/>
													</div>

													<Flex flexDir="column" justify="flex-end">
														<button
															type="submit"
															className="button-save"
															disabled={condPagDisabled}
															onClick={handleQtdParcelas}
															style={{ margin: 0 }}
														>
															&nbsp;&nbsp;&nbsp;Criar&nbsp;&nbsp;&nbsp;
														</button>
													</Flex>
												</Stack>
											</Stack>
										</Flex>
									</FormView>

									{parcelas.length > 0 && (
										<Flex
											flexDir="column"
											borderWidth={2}
											borderColor="gray.100"
											borderRadius={6}
											px={2}
											my={2}
											mb={10}
											h="auto"
											overflowY="scroll" scrollBehavior="smooth"
										>
											<Table size="sm">
												<Thead>
													<Tr>
														<Th></Th>
														<Th>Parcela</Th>
														<Th isNumeric>Valor</Th>
														<Th isNumeric>Vencimento</Th>
													</Tr>
												</Thead>

												<Tbody>
													{parcelas.map(parcela => {
														return (
															<Tr key={parcela.id}
																cursor={titulo.baixas && titulo.baixas.length > 0 ? "" : "pointer"}
																onClick={() => {
																	if (titulo.baixas && titulo.baixas.length > 0) {
																		return;
																	}
																	setParcelaModal(parcela);
																	setIsOpenModalParcelaEdit(true);
																}}
															>
																<Td pr={0} mr={0}>
																	<Icon
																		as={FiEdit}
																		color="blue.500"
																		fontSize={18}
																		cursor="pointer"
																		onClick={() => {}}
																	/>
																</Td>
																<Td>
																	<Flex>
																	{parcela.parcela}
																	{parcela.amortizado > 0 && (
																		<Text
																			fontSize={10}
																			fontWeight={500}
																			color="blue.500"
																			borderWidth={1}
																			borderColor="blue.500"
																			borderRadius={8}
																			px={1} ml={2}
																		>
																			pago
																		</Text>
																	)}
																	</Flex>
																</Td>
																<Td isNumeric>{formatPrice(parcela.vlr_cred !== 0 ? parcela.vlr_cred : parcela.vlr_deb)}</Td>
																<Td isNumeric>
																	{format(add(new Date(parcela.vencimento), { days: 1 }),
																		"dd'/'MM'/'yyyy", { locale: ptBR })}
																</Td>
															</Tr>
														)
													})}
												</Tbody>

												<Tfoot>
													<Tr>
														<Th></Th>
														<Th>Parcela</Th>
														<Th isNumeric>{formatPrice(totalParcelas)}</Th>
														<Th isNumeric>Vencimento</Th>
													</Tr>
												</Tfoot>
											</Table>
										</Flex>
									)}
									
									<Buttons>
										<Flex flexDir="column" pl={4} py={0}>
											<Text fontSize={[10, 14]} fontWeight={400}>Usuário:</Text>
											<Text pl={2} fontSize={[11, 15]} fontWeight={500}>{user.nome}</Text>
										</Flex>

										<Flex className="buttons">
											<button
												type="button"
												className="button-cancel"
												onClick={() => {
													setTextAlert({
														header: `Cancelar ${titulo.id ? 'Alteração' : 'Criação'} do Título!`,
														body: 'Você não salvou suas alterações!' + "\n" + 'Deseja sair sem salvar?',
														is_toast: true,
													});
													setOpenAlert(true);
												}}
											>
												Cancelar
											</button>

											<button
												type="button"
												className="button-save"
												onClick={handleSubmitParcelas}
											>
												Proximo
											</button>
										</Flex>
									</Buttons>
								</div>
							</TabParcela>

							<TabConta className="tab-panel" overflowY="scroll" scrollBehavior="smooth">
								<div className="tab-content">
									<Header>
										<h1>Contas</h1>
										<h2>Selecione as suas contas.</h2>
									</Header>

									<Divider my={0} />

									<FormView ref={formRefConta} onSubmit={handleSubmitGrausConta}>
										{/* GRAU 1 - GRAU 2 */}
										<Stack w="100%" spacing={[0, 4]} direction={['column', 'column', 'row']}>
											{/* GRAU 1 */}
											{grauContas?.grau_1?.length > 0 && (
												<div className="input">
													<p>Grau 1</p>
													<SelectInput
														name="grau_1"
														placeholder="Selecione grau 1"
														options={grauContas.grau_1}
													/>
												</div>
											)}

											{/* GRAU 2 */}
											{grauContas?.grau_2?.length > 0 && (
												<div className="input">
													<p>Grau 2</p>
													<SelectInput
														name="grau_2"
														placeholder="Selecione grau 2"
														options={grauContas.grau_2}
													/>
												</div>
											)}
										</Stack>

										{/* GRAU 3 - GRAU 4 */}
										{grauContas.qtd_grau >= 3 && (
											<Stack w="100%" spacing={[0, 4]} direction={['column', 'column', 'row']} mt={-3}>
												{/* GRAU 3 */}
												{grauContas?.grau_3?.length > 0 && (
													<div className="input">
														<p>Grau 3</p>
														<SelectInput
															name="grau_3"
															placeholder="Selecione grau 3"
															options={grauContas?.grau_3}
														/>
													</div>
												)}

												{/* GRAU 4 */}
												{grauContas?.grau_4?.length > 0 && (
													<div className="input">
														<p>Grau 4</p>
														<SelectInput
															name="grau_4"
															placeholder="Selecione grau 4"
															options={grauContas.grau_4}
														/>
													</div>
												)}
											</Stack>
										)}

										{/* GRAU 5 */}
										{grauContas?.qtd_grau === 5 && (
											<Stack w="100%" spacing={[0, 4]} direction={['column', 'column', 'row']} mt={-3}>
												{/* GRAU 5 */}
												<div className="input">
													<p>Grau 5</p>
													<SelectInput
														name="grau_5"
														placeholder="Selecione grau 5"
														options={grauContas.grau_5}
													/>
												</div>
											</Stack>
										)}

										{/* VALOR - BTN ADD  */}
										<Stack spacing={[0, 4]} direction="row" w="100%" mt={-1}>
											<div className="input">
												<p>Valor</p>
												<Input
													name="valor"
													placeholder="Valor"
													onChange={(e: any) => {
														formatInputMoeda('valor', formRefConta);
														handleVerifValor(e.target.value);
													}}
													containerStyle={{ padding: '7px 10px' }}
												/>
											</div>

											<Flex flexDir="column" justify="flex-end" w="100%" h="100%">
												<button
													type="submit"
													className="button-save"
													disabled={isDisabledButton}
													style={{ padding: '8px 20px', width: '9rem' }}
												>
													Adicionar
												</button>
											</Flex>
										</Stack>

										{/* MSG Valor Superior  */}
										<Flex w="100%" pt={0.5}>
											<Text
												id="valor_conta"
												fontSize={12}
												color="red.900"
												visibility="hidden"
											>
												Valor superior ao valor do título!
											</Text>
										</Flex>
									</FormView>

									{contas.length > 0 && (
										<Flex
											flexDir="column"
											borderWidth={2}
											borderColor="gray.100"
											borderRadius={6}
											px={2}
											my={2}
											mb={10}
											h="auto"
											overflowY="scroll" scrollBehavior="smooth"
										>
											<Table size="sm">
												<Thead>
													<Tr>
														<Th></Th>
														<Th>Número</Th>
														<Th>Descrição</Th>
														<Th isNumeric>Valor</Th>
													</Tr>
												</Thead>

												<Tbody>
													{contas.map(conta => {
														return (
															<Tr key={conta.id}>
																<Td pr={0} mr={0}>
																	<Icon
																		as={FiTrash2}
																		color="red.800"
																		fontSize={18}
																		cursor="pointer"
																		onClick={() => handleRemoveGrauConta(conta.id)}
																	/>
																</Td>
																<Td>{conta.id}</Td>
																<Td>{conta.nome}</Td>
																<Td isNumeric>
																	{formatPrice(conta.vlr_cred !== 0 ? conta.vlr_cred : conta.vlr_deb)}
																</Td>
															</Tr>
														)
													})}
												</Tbody>

												<Tfoot>
													<Tr>
														<Th></Th>
														<Th>Número</Th>
														<Th>Descrição</Th>
														<Th isNumeric>Valor</Th>
													</Tr>
												</Tfoot>
											</Table>
										</Flex>
									)}

									<Buttons>
										<Flex flexDir="column" pl={4} py={0}>
											<Text fontSize={[10, 14]} fontWeight={400}>Usuário:</Text>
											<Text pl={2} fontSize={[11, 15]} fontWeight={500}>{user.nome}</Text>
										</Flex>

										<Flex className="buttons">
											<button
												type="button"
												className="button-cancel"
												onClick={() => {
													setTextAlert({
														header: `Cancelar ${titulo.id ? 'Alteração' : 'Criação'} do Título!`,
														body: 'Você não salvou suas alterações!' + "\n" + 'Deseja sair sem salvar?',
														is_toast: true,
													});
													setOpenAlert(true);
												}}
											>
												Cancelar
											</button>

											<button
												type="button"
												className="button-save"
												onClick={handleSubmitCadastro}
											>
												Salvar
											</button>
										</Flex>
									</Buttons>
								</div>
							</TabConta>
						</TabPanels>
					</Tabs>
				</TabsView>
      </Content>

			{modalCadastroClienteVisible && (
				<ModalCadastroCliente
					isVisible={modalCadastroClienteVisible}
					onClose={setModalCadastroClienteVisible}
					searchCliente={searchCliente}
				/>
			)}

			{isOpenModalParcelaEdit && (
				<ModalParcelaEdit
					isOpen={isOpenModalParcelaEdit}
					onRequestClose={setIsOpenModalParcelaEdit}
					parcela={parcelaModal}
					parcelas={parcelas}
					total={formRef.current?.getFieldValue('vlr_doc')}
				/>
			)}

			{openAlert && (
				<Alert
					isOpen={openAlert}
					onRequestClose={setOpenAlert}
					textAlert={textAlert}
					execFunction={handleCancel}
				/>
			)}
    </Container>
  );
};

export default ModalTituloEdit;
